export default "__VITE_ASSET__e0670fb0__"